import React from "react";

/* get started button in hero element */
export function HeroGetStarted() {
  return (
    <button type="button" className="py-3 px-6 sm:w-[60%] my-4 bg-indigo-700">
      Get Started
    </button>
  );
}
